import React from "react";
import label from "../../labels/recommendationProcess_en.json";

const Recommendation = () => {
  return (
    <div className="dashboardContentArea">
      <h5> {label.Recommendation} </h5>
      <div className="row dashboardCards"></div>
    </div>
  );
};

export default Recommendation;
